const companyStatus = {
  ACTIVE: 'ACTIVE',
  REMOVED: 'REMOVED',
  BLOCKED: 'BLOCKED',
  ANALYSIS: 'ANALYSIS',
  REJECTED: 'REJECTED',
  CLOSED: 'CLOSED'
};

module.exports = companyStatus;
